import { render, staticRenderFns } from "./proedit.vue?vue&type=template&id=ba429b4c&scoped=true"
import script from "./proedit.vue?vue&type=script&lang=js"
export * from "./proedit.vue?vue&type=script&lang=js"
import style0 from "./proedit.vue?vue&type=style&index=0&id=ba429b4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba429b4c",
  null
  
)

export default component.exports